import { useCallback, useEffect, useState } from 'react';
import PageTemplate from 'components/template/PageTemplate';
import Container from 'components/common/Container';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { jsonAxios } from 'components/axios';
import Bg1 from 'assets/mypage/issue.avif'
import { ReactComponent as Light } from 'assets/news/light.svg'
import { ReactTyped } from "react-typed";
import CustomButton from 'components/common/CustomButton';
import { toast } from 'react-toastify';

const IssueDetail = () => {
    interface IData {
        id: number,
        title: string,
        transportType: string,
        aiResponse: string,
        blNo: string,
        createAt: string
        content: string
    }
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const id = searchParams.get('id');
    const [data, setData] = useState<IData>({} as IData);

    const init = useCallback(() => {
        if (!id) {
            toast.error('잘못된 경로입니다.');
            setTimeout(() => {
                navigate(-1);
            }, 500);
            return;
        }
        const reqData = {
            issueId: id
        }
        jsonAxios.post(`issue/users`, reqData).then(res => {
            console.log(res.data)
            if (res.data.code == 200) {
                setData(res.data.data)
            }
        })
    }, [id])

    useEffect(() => {
        init()
    }, [init])

    return (
        <PageTemplate background='bg-[#F8F8FA]'>
            <div
                className="relative flex justify-center items-center bg-primary bg-cover h-60 mobile:h-30 text-white"
                style={{
                    backgroundPosition: "center",
                    backgroundImage: `url(${Bg1})`,
                }}
            >
                <div className='flex flex-col justify-center items-center gap-2'>
                    <p className='font-semibold text-32 tablet:text-2xl'>BL No. {data.blNo}</p>
                    <p className='tablet:text-lg text-2xl'>사고 이슈와 상세 내용을 확인해보세요</p>
                </div>
            </div>
            <Container className="mb-6 py-10 tablet:pt-6 h-full min-h-dvh">
                <div className='bg-white mb-10 rounded-lg'>
                    <div className='flex tablet:flex-col justify-between items-center tablet:items-start px-10 tablet:px-4 py-6 border-[#F8F8FA] border-b-2'>
                        <p className='font-semibold tablet:text-lg text-2xl'>{data.title} <br className='hidden tablet:block' />{data.blNo ? `BL No. ${data.blNo}` : ''}</p>
                        <p className='tablet:w-full tablet:text-base text-lg tablet:text-right'>{data.createAt}</p>
                    </div>
                    <div className='flex flex-col gap-10 tablet:p-4 px-10 py-6'>
                        {/* <div className='h-[590px] overflow-hidden'>
                            <img
                                className='w-full object-cover'
                                src="https://img9.yna.co.kr/photo/etc/epa/2025/06/11/PEP20250611159401009_P4.jpg"
                                alt=""
                            />
                        </div> */}
                        {
                            data.aiResponse &&
                            <div className='bg-[#F8F8FA] p-10'>
                                <div className='flex justify-start items-center gap-2 mb-10'>
                                    <Light />
                                    <p className='font-semibold text-primary text-2xl'>솔로몬쉽 AI 요약</p>
                                </div>
                                <p>
                                    <ReactTyped
                                        strings={[`
                                        발단 <br />
                                        지난 5일간 태국과 캄보디아 국경 지역에서 무력 충돌이 이어지면서 최소 33명이 사망하고 수만 명이 피난길에 올랐습니다. 100년 넘게 이어진 국경 분쟁은 올해 5월 캄보디아 군인 사망 사고를 시작으로 다시 고조되었습니다. 교전이 격화되자 태국은 국경 검문소를 폐쇄하고 캄보디아와의 외교 관계를 격하하는 등 강력하게 대응했습니다.<br /><br />
                                        전개<br />
                                        교전이 계속되는 가운데, 9월 28일 말레이시아 쿠알라룸푸르에서 양국 간 평화 회담이 열렸습니다. 말레이시아의 중재 노력에도 불구하고, 회담 중에도 포탄과 로켓포가 오가는 등 긴장감은 여전했습니다. 특히 미국 대통령이 관세 협상 중단을 경고하자, 태국은 결국 중재를 받아들이며 휴전 논의가 급물살을 타게 되었습니다.<br /><br />
                                        결말<br />
                                        치열한 논의 끝에, 태국과 캄보디아는 28일(현지시간) **"즉각적이고 조건 없는 휴전"**에 합의했습니다. 말레이시아 총리는 이번 합의가 평화 회복의 중요한 첫걸음이라고 평가하며, 휴전은 자정부터 공식 발효된다고 발표했습니다. 양국은 병력 철수와 독립적인 감시 체제 수용에도 합의할 예정이며, 아세안 회원국들이 휴전 이행 감시를 지원할 예정입니다.
                                    `]}
                                        typeSpeed={5}
                                        showCursor={false}
                                        onComplete={() => {
                                            // handleComplete()
                                        }}
                                    />
                                </p>
                            </div>
                        }
                        <div className='min-h-[50vh]' dangerouslySetInnerHTML={{ __html: data.content }}></div>
                    </div>
                </div>
                <div className='flex justify-center items-center w-full'>
                    <CustomButton
                        className='flex-1 bg-primary max-w-[600px]'
                        title='사고/이슈 목록이동'
                        onClick={() => {
                            navigate(-1)
                        }}
                    />
                </div>
            </Container>
        </PageTemplate>
    )
}

export default IssueDetail